module.exports = __webpack_public_path__ + "static/media/icona catalogo.5252889a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icona catalogo.png
// module id = 100
// module chunks = 0